import gql from 'graphql-tag';
import {
  CART_AMOUNTS_FRAGMENT,
  SHIPPING_METHODS_FRAGMENT,
} from '@/lib/graphql';

/**
 * GraphQL mutation for server-side shipping address callback.
 *
 * This mutation can be used in both guest and signup use cases
 *
 */
export const UPDATE_GUEST_SHIPPING_ADDRESS_CALLBACK_MUTATION = gql`
  mutation UpdateGuestShippingAddressCallbackMutation(
    $token: String!
    $address: GuestAddressInput!
  ) {
    updateGuestShippingAddressCallback(token: $token, address: $address) {
      cart {
        ...CartAmounts
        ...ShippingMethods
        items {
          __typename
          name
          quantity
        }
      }
    }
  }

  ${CART_AMOUNTS_FRAGMENT}
  ${SHIPPING_METHODS_FRAGMENT}
`;
